import { EventCsvHeaders } from 'src/api/types/misc';

export const generateCsvTemplateLink = () => {
  const csvString = Object.values(EventCsvHeaders).join(';') + '\n';
  const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' });
  return URL.createObjectURL(blob);
};

export const pathNames: Record<string, string> = {
  id: EventCsvHeaders.ID,
  notes: EventCsvHeaders.Title,
  assignedTo: EventCsvHeaders.Owner,
  dueDate: EventCsvHeaders.DueDate,
  completionStatus: EventCsvHeaders.CompletionStatus,
  completedAt: EventCsvHeaders.DateCompleted,
  completedBy: EventCsvHeaders.CompletedBy,
};

export interface EventCSV {
  [EventCsvHeaders.ID]: string;
  [EventCsvHeaders.Owner]: string;
  [EventCsvHeaders.Title]: string;
  [EventCsvHeaders.CompletionStatus]: string;
  [EventCsvHeaders.DueDate]: string;
  [EventCsvHeaders.DateCompleted]: string;
  [EventCsvHeaders.CompletedBy]: string;
  [EventCsvHeaders.Created]: string;
}
